import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "AWS Certified Solutions Architect",
          "AWS Certified AI Practitioner",
          "AI Developer (LLM Engineering, Agentic AI, MCP)",
          "Senior Full Stack Developer",
          "Backend Developer",
          "Solution Architect",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 1,
        delay: 1,
      }}
    />
  );
}

export default Type;
